export const FULFILLMENT_STATUSES = ["pending", "purchased", "qc_and_packed", "out_for_delivery", "delivered", "user_rated"];

export const formatOrderStatus = (value) => String(value || "pending")
  .replaceAll("_", " ")
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

export const formatOpsCurrency = (value) => Number(value || 0).toLocaleString("en-NG", {
  style: "currency",
  currency: "NGN",
  maximumFractionDigits: 0,
});

export const formatOpsDate = (value) => value
  ? new Date(value).toLocaleString("en-NG", { dateStyle: "medium", timeStyle: "short" })
  : "Not available";

export const formatDeliveryDate = (value) => value
  ? new Date(value).toLocaleDateString("en-NG", { day: "numeric", month: "short", year: "numeric" })
  : "Delivery date not set";

export const dateOnly = (value) => value ? String(value).slice(0, 10) : "";

export const formatDeliveryAddress = (location) => [location?.street, location?.city, location?.state]
  .filter(Boolean)
  .join(", ") || "Delivery address unavailable";

export const orderStatusTone = (status) => (
  ["delivered", "user_rated", "purchased"].includes(status)
    ? "success"
    : status === "pending" ? "pending" : "info"
);

export const updatedByLabel = (updatedBy) => typeof updatedBy === "string"
  ? updatedBy
  : updatedBy?.name || updatedBy?.email || updatedBy?.user_id || "";

export const getPaginationItems = (currentPage, totalPages) => {
  if (totalPages <= 5) return Array.from({ length: totalPages }, (_, index) => index + 1);
  const items = [1];
  if (currentPage > 3) items.push("start-ellipsis");
  for (let page = Math.max(2, currentPage - 1); page <= Math.min(totalPages - 1, currentPage + 1); page += 1) items.push(page);
  if (currentPage < totalPages - 2) items.push("end-ellipsis");
  items.push(totalPages);
  return items;
};

export const userInitials = (user) => {
  const name = user.contact_name || user.email || "Customer";
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join("").toUpperCase();
};

export const groupUsersByDeliveryDate = (users) => {
  const groups = new Map();
  users.forEach((user) => {
    const key = `${user.user_id || user.email || user.contact_name}-${user.delivery_date || "unscheduled"}`;
    const existing = groups.get(key);
    if (existing) {
      existing.items.push(...(Array.isArray(user.items) ? user.items : []));
      existing.total_amount_paid += Number(user.total_amount_paid || 0);
      existing.total_buy_in_amount += Number(user.total_buy_in_amount || 0);
      existing.total_delivery_fee += Number(user.total_delivery_fee || 0);
      existing.total_items += Number(user.total_items || user.items?.length || 0);
      return;
    }
    groups.set(key, {
      ...user,
      items: [...(Array.isArray(user.items) ? user.items : [])],
      total_amount_paid: Number(user.total_amount_paid || 0),
      total_buy_in_amount: Number(user.total_buy_in_amount || 0),
      total_delivery_fee: Number(user.total_delivery_fee || 0),
      total_items: Number(user.total_items || user.items?.length || 0),
    });
  });
  return [...groups.values()];
};
